import '../styles/main.css';
import '../styles/CustomSelect.css';

import FarolFormContainer           from '../components/Form/FarolFormContainer';
import FarolTextModal               from '../components/Modals/FarolTextModal';
import { useFarol }                 from '../contexts/FarolPageContext'; 
import FarolCardsSection            from '../components/Sections/FarolCardsSection';
import FarolTerminalFormContainer   from '../components/Form/FarolTerminalFormContainer';
import FarolPageFilter              from '../components/Filters/FarolPageFilter';

function FarolManagePage() {

    const { handleFarolTextModalOpen, cardsLayout, toggleCardsLayout } = useFarol();

    return (
       
        <section className="pg-content flex flex-col gap-[1.25rem]">
            
            <FarolTerminalFormContainer />

            <FarolFormContainer />

            <FarolTextModal />
            

            <h1>Farol dos Terminais</h1>

            <FarolPageFilter />

            <div className="flex gap-[10px]">

                <button className="btn-amarelo" onClick={handleFarolTextModalOpen}>
                    Obter texto
                </button>

                {/* O ícone mostra o layout para o qual o botão troca: grade (lado a lado) ou barras (empilhado). */}
                <button
                    className="btn-amarelo flex items-center justify-center !px-[6px]"
                    onClick={toggleCardsLayout}
                    title={cardsLayout === 'empilhado' ? 'Cards lado a lado' : 'Cards empilhados'}
                    aria-label={cardsLayout === 'empilhado' ? 'Cards lado a lado' : 'Cards empilhados'}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]" aria-hidden="true">
                        {cardsLayout === 'empilhado' ? (
                            <>
                                <rect x="3"  y="3"  width="7" height="7" rx="1" />
                                <rect x="14" y="3"  width="7" height="7" rx="1" />
                                <rect x="3"  y="14" width="7" height="7" rx="1" />
                                <rect x="14" y="14" width="7" height="7" rx="1" />
                            </>
                        ) : (
                            <>
                                <path d="M4 6h16" />
                                <path d="M4 12h16" />
                                <path d="M4 18h16" />
                            </>
                        )}
                    </svg>
                </button>

            </div>

            <FarolCardsSection />

        
        </section>
    )
}

export default FarolManagePage;